export default __webpack_public_path__ + "static/media/15.41130f50.jpg";